import React from 'react'
import UserDepartment from '../../components/UserDepartment/UserDepartment'

function UserDepartmentPage() {
  return (
    <UserDepartment />
  )
}

export default UserDepartmentPage